import * as signalR from '@microsoft/signalr';
import type { ListChatGroupDto, ListChatMessageByGroupDto, ChatGroupDetailDto } from "~/core/services/ApiClient";
const config = useRuntimeConfig();
export class SignalRService {
    private static connection: signalR.HubConnection

    static startConnection(token: string) {
        if (!this.connection) {
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl(config.public.systemHubUrl, {
                    accessTokenFactory: () => token
                })
                .build()

            this.connection.start()
                .then(() => console.log('Connected to SignalR Server'))
                .catch((err) => console.error('Error connecting to SignalR: ', err))
        }
    }

    static sendMessage(data: object) {
        if (this.connection) {
            this.connection.send('SendMessageToGroup', data);
            console.log('ggửi mess', data);
        }
    }

    static onReceiveMessage(callback: (data: object) => void) {
        if (this.connection) {
            this.connection.on('ReceiveMessage', callback);
        }
    }
    static onUserOnline(callback: (data: number) => void) {
        if (this.connection) {
            this.connection.on('UserOnline', callback);
        }
    }

    static onUserOffline(callback: (data: number) => void) {
        if (this.connection) {
            this.connection.on('UserOffline', callback);
        }
    }

    static sendReadMessage(chatGroupId: number) {
        if (this.connection) {
            this.connection.send('SendReadMessage', chatGroupId);
            console.log('Đánh dấu đọc tin nhắn', chatGroupId);
        }
    }
    static onReadMessage(callback: (data: object) => void) {
        if (this.connection) {
            this.connection.on('ReadMessage', callback);
        }
    }
}